import { useCallback, useState } from 'react';

const useNodeStates = () => {
  const [nodeStatesMap, setNodeStatesMap] = useState<Map<string, any>>(new Map());

  const setNodeState = useCallback((nodeId: string, updatedState: any) => {
    setNodeStatesMap((prev) => new Map([...Array.from(prev.entries()), [nodeId, updatedState]]));
  }, []);

  const getNodeState = useCallback(
    (nodeId: string) => {
      return nodeStatesMap.get(nodeId);
    },
    [nodeStatesMap],
  );

  return { setNodeState, getNodeState };
};

export default useNodeStates;
